import React from 'react';

const CloudInfraImg = ({ theme }) => (
  <svg
    id="1dff4cb4-53bd-4ffc-acc1-5e8a2ceb72de"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width="864.81"
    height="658.45"
    viewBox="0 0 864.81 658.45"
  >
    <defs>
      <linearGradient
        id="e6219774-622b-406f-ae45-f26a74b1f5cd"
        x1="477.09"
        y1="779.22"
        x2="477.09"
        y2="120.78"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="gray" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
        <stop offset="1" stopColor="gray" stopOpacity="0.1" />
      </linearGradient>
      <linearGradient
        id="2394db48-9094-48a1-80b4-38413320a0c3"
        x1="309.42"
        y1="623"
        x2="309.42"
        y2="461"
      />
      <linearGradient
        id="894cb520-7283-4f65-92a7-edb841614828"
        x1="773.42"
        y1="549"
        x2="773.42"
        y2="387"

      />
      <linearGradient
        id="43bfcda2-dcfb-4411-a28b-16db327cb63c"
        x1="664.42"
        y1="277"
        x2="664.42"
        y2="115"
      />
    </defs>
    <title>cloud hosting</title>
    <g opacity="0.7">
      <path
        d="M506.4,473.94l-.59-.14V451.2a120.23,120.23,0,0,0,89.79-97.09l.29,0c5.77,0,10.44-8.77,10.44-19.58,0-6.71-1.8-12.62-4.54-16.15q.62-6.2.63-12.57a125,125,0,0,0-38.62-90.49,80.54,80.54,0,0,0-8.87-23.81c-8.9-15.68-23.71-32-17.67-49l-39.1,4-.36-25.76c-12.2,2.19-17.31,16.33-24.55,26.4-17.41,24.22-52.35,27.59-75.46,46.45-7.85,6.41-25.51,25.9-22.19,38.68a124.75,124.75,0,0,0-23.84,73.53q0,6.36.63,12.57c-2.74,3.53-4.54,9.44-4.54,16.15,0,10.82,4.68,19.58,10.44,19.58l.29,0a120.23,120.23,0,0,0,89.79,97.09v22.6l-.59.14C434.32,472.37,298.48,462,328.27,685.4l18.27,67.36,4.07-.16A28.72,28.72,0,0,0,407,757.71c25.87-.09,55.09-.17,70-.17s44.18.09,70,.17a28.72,28.72,0,0,0,56.44-5.11l4.07.16,18.27-67.36C655.71,462,519.86,472.37,506.4,473.94Z"
        transform="translate(-167.6 -120.78)"
        fill="url(#e6219774-622b-406f-ae45-f26a74b1f5cd)"
      />
    </g>
    <rect y="625.16" width="645.61" height="21.88" fill="#e0e0e0" />
    <rect
      x="27.36"
      y="647.05"
      width="590.89"
      height="8.95"
      fill="#e0e0e0"
    />
    <rect x="27.36" y="647.05" width="590.89" height="2.98" opacity="0.1" />
    <path
      d="M361,747.61s86.63-.34,116.09-.34,116.09.34,116.09.34V735H361Z"
      transform="translate(-167.6 -120.78)"
      opacity="0.1"
    />
    <path
      d="M593.19,745.08s-86.63-.34-116.09-.34-116.09.34-116.09.34V585.74A116.09,116.09,0,0,1,477.09,469.65h0A116.09,116.09,0,0,1,593.19,585.74Z"
      transform="translate(-167.6 -120.78)"
      fill={theme.imageHighlight}
    />
    <path
      d="M298.5,290.83h22a16.76,16.76,0,0,1,16.76,16.76v46.33a27.76,27.76,0,0,1-27.76,27.76h0a27.76,27.76,0,0,1-27.76-27.76V307.59A16.76,16.76,0,0,1,298.5,290.83Z"
      fill="#fdb797"
    />
    <path
      d="M449.33,453.67a116.17,116.17,0,0,0,55.52,0V414.13H449.33Z"
      transform="translate(-167.6 -120.78)"
      opacity="0.1"
    />
    <circle cx="309.5" cy="189.88" r="121.14" fill="#333" />
    <circle cx="309.5" cy="217.64" r="116.09" fill="#fdb797" />
    <path
      d="M400.44,202.19c22.33-18.23,56.11-21.48,72.94-44.9,7-9.73,11.93-23.4,23.73-25.52l.35,24.9,37.79-3.88c-5.83,16.42,8.48,32.23,17.08,47.38a77.93,77.93,0,0,1,10.09,36.68c-13.12,7.88-29.39-.72-44-5.31-14.2-4.46-29.29-4.92-44.17-5.34-7.63-.22-15.35-.42-22.8,1.25-6.53,1.47-12.64,4.34-18.82,6.93-10.05,4.21-41.79,20.09-51.13,9.85C370.92,232.62,391.82,209.23,400.44,202.19Z"
      transform="translate(-167.6 -120.78)"
      fill="#333"
    />
    <path
      d="M406.75,280.2c6.16,3.73,13.4,5.2,20.53,6.18a180.86,180.86,0,0,0,88.11-9.9c4.6,11.66,15.83,19.67,27.77,23.48s24.69,4,37.22,4.15c2.76,0,5.72,0,8-1.53,5.58-3.77,2.88-12.4-.37-18.3L571.84,255c-4.78-8.66-9.7-17.5-17.1-24.06-9.28-8.21-21.6-12.06-33.75-14.49a190.34,190.34,0,0,0-86.64,2.89C404.13,227.47,365.31,255.12,406.75,280.2Z"
      transform="translate(-167.6 -120.78)"
      opacity="0.1"
    />
    <path
      d="M406.75,277.68c6.16,3.73,13.4,5.2,20.53,6.18a180.86,180.86,0,0,0,88.11-9.9c4.6,11.66,15.83,19.67,27.77,23.48s24.69,4,37.22,4.15c2.76,0,5.72,0,8-1.53,5.58-3.77,2.88-12.4-.37-18.3l-16.17-29.32c-4.78-8.66-9.7-17.5-17.1-24.06-9.28-8.21-21.6-12.06-33.75-14.49a190.34,190.34,0,0,0-86.64,2.89C404.13,224.94,365.31,252.59,406.75,277.68Z"
      transform="translate(-167.6 -120.78)"
      fill="#333"
    />
    <ellipse cx="424.33" cy="217.64" rx="10.1" ry="18.93" fill="#fdb797" />
    <ellipse cx="194.67" cy="217.64" rx="10.1" ry="18.93" fill="#fdb797" />
    <path
      d="M504.39,473.27S651.23,450.4,620.95,677.54l-17.66,65.11-50.48-2s32.81-75.71,12.62-126.19S504.39,473.27,504.39,473.27Z"
      transform="translate(-167.6 -120.78)"
      fill={theme.imageHighlight}
    />
    <path
      d="M449.8,473.27S303,450.4,333.24,677.54l17.66,65.11,50.48-2s-32.81-75.71-12.62-126.19S449.8,473.27,449.8,473.27Z"
      transform="translate(-167.6 -120.78)"
      fill={theme.imageHighlight}
    />
    <path
      d="M386.24,573.36s-10.1,78,7.57,100.71"
      transform="translate(-167.6 -120.78)"
      opacity="0.1"
    />
    <path
      d="M567.95,575.36s10.1,76-7.57,98.71"
      transform="translate(-167.6 -120.78)"
      opacity="0.1"
    />
    <circle cx="404.08" cy="619.68" r="27.76" fill="#fdb797" />
    <circle cx="214.91" cy="619.68" r="27.76" fill="#fdb797" />
    <g opacity="0.7">
      <rect
        x="218.04"
        y="461"
        width="182.77"
        height="162"
        rx="21.34"
        ry="21.34"
        fill="url(#2394db48-9094-48a1-80b4-38413320a0c3)"
      />
    </g>
    <rect
      x="221.42"
      y="464"
      width="176"
      height="156"
      rx="21.34"
      ry="21.34"
      fill="#e0e0e0"
    />
    <path
      d="M443.45,729.71V718a1.16,1.16,0,0,0-1.32-1.18,12.53,12.53,0,0,0-4.83,1.07v11.79H434V708h3.29v7.16a15.7,15.7,0,0,1,5.29-1.07c3,0,4.11,1.84,4.11,4.36v11.25h-3.26Zm9.41-7.08c.11,3.92.88,4.69,3.29,4.69a17,17,0,0,0,5.68-1.26l.55,2.47a15.37,15.37,0,0,1-6.44,1.56c-5.49,0-6.34-3-6.34-7.82a26.07,26.07,0,0,1,.82-7.21,18.82,18.82,0,0,1,6.61-1c4.5,0,5.87,2.5,5.87,6.86v1.67h-10Zm4.17-5.79a22.05,22.05,0,0,0-3.84.27,17.45,17.45,0,0,0-.36,3.24h6.86c0-2.28-.41-3.51-2.66-3.51Zm12,1.07v11.79h-3.29V716.43a19,19,0,0,1,7.63-2.11v2.74a14,14,0,0,0-4.33.85Zm13,12.18c-4.91,0-7.13-2.41-7.13-7.93,0-5.84,2.93-8.06,7.13-8.06,4.91,0,7.13,2.41,7.13,7.93,0,5.84-2.94,8.06-7.13,8.06Zm0-13.25c-2.52,0-3.92,1.45-3.92,5.32,0,4.22,1.18,5.16,3.92,5.16,2.52,0,3.92-1.43,3.92-5.29,0-4.22-1.18-5.18-3.92-5.18Zm23,12.86h-3.87a21.44,21.44,0,0,0-4.11-7h-1.73v7H492.1V708h3.29v12.45h1.54a20,20,0,0,0,3.87-6h3.7a25.74,25.74,0,0,1-4.69,6.64,46.5,46.5,0,0,1,5.29,8.58Zm6.17.38c-3,0-4.11-1.84-4.11-4.36V714.49h3.26v11.66a1.16,1.16,0,0,0,1.32,1.18,13.31,13.31,0,0,0,5-1.07V714.49H520v13.22A17.45,17.45,0,0,1,511.27,730.09Zm-1.45-27.61H444.18A10.16,10.16,0,0,1,434,692.32V606.07a10.16,10.16,0,0,1,10.16-10.16h65.63A10.17,10.17,0,0,1,520,606.07v86.25a10.16,10.16,0,0,1-10.17,10.16Z"
      transform="translate(-167.6 -120.78)"
      fill="#6762a6"
    />
    <path
      d="M487.89,687.82V645.5s2.75-10.13-33.91,4.14c-.07.18-.07-39.14-.07-39.14l12-.07v25.19s33.54-13.21,33.54,10v42.18H487.89Zm6.83-62.15H482c4.57-5.59,8.71-15.17,8.71-15.17h13.14s-2.25,6.24-9.15,15.17Zm-40.59,62.07v-24.1l12.05,12.05-12.05,12.05Z"
      transform="translate(-167.6 -120.78)"
      fill="#fff"
    />
    <g opacity="0.7">
      <rect
        x="682.04"
        y="387"
        width="182.77"
        height="162"
        rx="21.34"
        ry="21.34"
        fill="url(#894cb520-7283-4f65-92a7-edb841614828)"
      />
    </g>
    <rect
      x="685.42"
      y="390"
      width="176"
      height="156"
      rx="21.34"
      ry="21.34"
      fill="#e0e0e0"
    />
    <path
      d="M909.6,577a14.49,14.49,0,0,0,.53,4.26,25.64,25.64,0,0,0,1.53,3.45,2.08,2.08,0,0,1,.34,1.1,1.9,1.9,0,0,1-.91,1.44l-3,2a2.3,2.3,0,0,1-1.25.43,2.2,2.2,0,0,1-1.44-.67,14.82,14.82,0,0,1-1.72-2.25c-.48-.81-1-1.72-1.48-2.83a17.69,17.69,0,0,1-14.08,6.61c-4,0-7.23-1.15-9.58-3.45a13.51,13.51,0,0,1,.81-19.06c2.92-2.49,6.8-3.74,11.73-3.74a37.92,37.92,0,0,1,5.08.38c1.77.24,3.59.62,5.51,1.05v-3.5c0-3.64-.77-6.18-2.25-7.66s-4.12-2.2-7.81-2.2a21.79,21.79,0,0,0-5.17.62,38.16,38.16,0,0,0-5.17,1.63,13.74,13.74,0,0,1-1.68.62,2.94,2.94,0,0,1-.77.14c-.67,0-1-.48-1-1.48v-2.35a3,3,0,0,1,.34-1.68,3.59,3.59,0,0,1,1.34-1,27.57,27.57,0,0,1,6-2.16,29,29,0,0,1,7.47-.91c5.7,0,9.87,1.29,12.55,3.88s4,6.51,4,11.78V577Zm-19.44,7.28a15.52,15.52,0,0,0,4.93-.86,10.67,10.67,0,0,0,4.55-3.07,7.6,7.6,0,0,0,1.63-3.07,17.19,17.19,0,0,0,.48-4.17v-2a40,40,0,0,0-4.41-.81,36.09,36.09,0,0,0-4.5-.29c-3.21,0-5.56.62-7.14,1.92a6.84,6.84,0,0,0,4.45,12.36Zm38.46,5.17a2.67,2.67,0,0,1-1.82-.48,3.9,3.9,0,0,1-1-1.87l-11.25-37a8.39,8.39,0,0,1-.43-1.92,1.05,1.05,0,0,1,1.15-1.2h4.69a2.65,2.65,0,0,1,1.87.48,3.92,3.92,0,0,1,1,1.87l8,31.71,7.47-31.71a3.36,3.36,0,0,1,.91-1.87,3.29,3.29,0,0,1,1.92-.48h3.83a2.88,2.88,0,0,1,1.92.48,3.23,3.23,0,0,1,.91,1.87l7.57,32.09,8.29-32.09a4.11,4.11,0,0,1,1-1.87,3.12,3.12,0,0,1,1.87-.48h4.45a1.06,1.06,0,0,1,1.2,1.2,4.78,4.78,0,0,1-.1.77,6.81,6.81,0,0,1-.34,1.2l-11.54,37a3.67,3.67,0,0,1-1,1.87,3.06,3.06,0,0,1-1.82.48h-4.12a2.88,2.88,0,0,1-1.92-.48,3.4,3.4,0,0,1-.91-1.92l-7.42-30.89-7.38,30.84a3.74,3.74,0,0,1-.91,1.92,3,3,0,0,1-1.92.48Zm61.54,1.29a31.69,31.69,0,0,1-7.38-.86,21.79,21.79,0,0,1-5.51-1.92,3.45,3.45,0,0,1-1.48-1.34,3.38,3.38,0,0,1-.29-1.34v-2.44c0-1,.38-1.48,1.1-1.48a2.71,2.71,0,0,1,.86.14c.29.1.72.29,1.2.48a26.05,26.05,0,0,0,5.27,1.68,28.76,28.76,0,0,0,5.7.57,12.92,12.92,0,0,0,7-1.58,5.16,5.16,0,0,0,2.49-4.55,4.66,4.66,0,0,0-1.29-3.35,12,12,0,0,0-4.84-2.49L986,570.1c-3.5-1.1-6.08-2.73-7.66-4.89a11.41,11.41,0,0,1-2.39-6.94,10.66,10.66,0,0,1,1.29-5.32,12.31,12.31,0,0,1,3.45-3.93,15.2,15.2,0,0,1,5-2.49,20.87,20.87,0,0,1,6-.81,24,24,0,0,1,3.21.19c1.1.14,2.11.34,3.11.53s1.87.48,2.73.77a10.45,10.45,0,0,1,2,.86,4.14,4.14,0,0,1,1.44,1.2,2.58,2.58,0,0,1,.43,1.58v2.25c0,1-.38,1.53-1.1,1.53a5,5,0,0,1-1.82-.57,21.91,21.91,0,0,0-9.2-1.87,12.36,12.36,0,0,0-6.37,1.34,4.62,4.62,0,0,0-2.25,4.26,4.52,4.52,0,0,0,1.44,3.4,14.31,14.31,0,0,0,5.27,2.63l6.8,2.16c3.45,1.1,5.94,2.63,7.42,4.6a10.84,10.84,0,0,1,2.2,6.71,12.31,12.31,0,0,1-1.25,5.56,12.88,12.88,0,0,1-3.5,4.21,15.44,15.44,0,0,1-5.32,2.68,22.77,22.77,0,0,1-6.85,1Z"
      transform="translate(-167.6 -120.78)"
      fill="#252f3e"
    />
    <path
      d="M999.21,614c-15.76,11.64-38.65,17.82-58.33,17.82a105.53,105.53,0,0,1-71.22-27.16c-1.48-1.34-.14-3.16,1.63-2.11a141.44,141.44,0,0,0,125.62,7.81c2.63-1.2,4.89,1.72,2.3,3.64Z"
      transform="translate(-167.6 -120.78)"
      fill="#f90"
    />
    <path
      d="M1005.77,606.55c-2-2.59-13.31-1.25-18.44-.62-1.53.19-1.77-1.15-.38-2.16,9-6.32,23.8-4.5,25.53-2.39s-.48,17-8.91,24c-1.29,1.1-2.54.53-2-.91C1003.52,619.76,1007.78,609.08,1005.77,606.55Z"
      transform="translate(-167.6 -120.78)"
      fill="#f90"
    />
    <g opacity="0.7">
      <rect
        x="573.04"
        y="115"
        width="182.77"
        height="162"
        rx="21.34"
        ry="21.34"
        fill="url(#43bfcda2-dcfb-4411-a28b-16db327cb63c)"
      />
    </g>
    <rect
      x="576.42"
      y="118"
      width="176"
      height="156"
      rx="21.34"
      ry="21.34"
      fill="#e0e0e0"
    />
    <path
      d="M807.53,357.41l-23.66-41,23.66-41h47.31l23.66,41-23.66,41H807.53"
      transform="translate(-167.6 -120.78)"
      fill="#cac9c2"
    />
    <path
      d="M832,335.14a18.44,18.44,0,1,1,18.44-18.44A18.46,18.46,0,0,1,832,335.14"
      transform="translate(-167.6 -120.78)"
      fill="#fff"
    />
    <path
      d="M869.08,261.72a10.13,10.13,0,0,0-7.91-4.57h-58.3a10.13,10.13,0,0,0-7.91,4.57l-17,29.5a9.69,9.69,0,0,0,1.06,5.35l11.53,19.71,20.58-35.56h65.06a9.5,9.5,0,0,1,4.76,1.5l-11.84-20.51"
      transform="translate(-167.6 -120.78)"
      fill="#5072aa"
    />
    <path
      d="M778.67,289.94l-.75,1.29a9.7,9.7,0,0,0,1.06,5.35l11.53,19.71,6.13-10.6-18-15.76"
      transform="translate(-167.6 -120.78)"
      fill="#4d6796"
    />
    <path
      d="M804.37,272.32a3.56,3.56,0,1,1,3.56-3.56,3.56,3.56,0,0,1-3.56,3.56m58.3-3.56a3.29,3.29,0,1,1-6.59.08s0-.06,0-.08a3.29,3.29,0,0,1,6.59,0Z"
      transform="translate(-167.6 -120.78)"
      fill="#fff"
    />
    <path
      d="M898.22,312.21l-17.31-30a9.5,9.5,0,0,0-4.76-1.5H852.7L873,316.49l-32.12,56.75a9.28,9.28,0,0,1-3.3,3.16h23.6a10.13,10.13,0,0,0,7.91-4.57l29.15-50.49a10.12,10.12,0,0,0,0-9.13"
      transform="translate(-167.6 -120.78)"
      fill="#cc4232"
    />
    <path
      d="M881.7,283.58l-.78-1.35a9.49,9.49,0,0,0-4.76-1.5H852.7l6.11,10.76,22.89-7.92"
      transform="translate(-167.6 -120.78)"
      fill="#b23f33"
    />
    <path
      d="M859.37,367.68a3.56,3.56,0,1,1,3.56-3.56,3.56,3.56,0,0,1-3.56,3.56m27.69-47.42a3.56,3.56,0,1,1,3.56-3.56,3.56,3.56,0,0,1-3.56,3.56"
      transform="translate(-167.6 -120.78)"
      fill="#fff"
    />
    <path
      d="M811.55,352.26,779,296.58a9.7,9.7,0,0,1-1.06-5.35l-12.11,21a10.13,10.13,0,0,0,0,9.13L795,371.83a10.13,10.13,0,0,0,7.91,4.56h34.69a9.28,9.28,0,0,0,3.3-3.16l11.88-21H811.55"
      transform="translate(-167.6 -120.78)"
      fill="#ecb02a"
    />
    <path
      d="M835.59,376.4h2a9.27,9.27,0,0,0,3.3-3.16l11.88-21H840.14l-4.55,24.14"
      transform="translate(-167.6 -120.78)"
      fill="#c79732"
    />
    <path
      d="M804.37,367.68a3.56,3.56,0,1,1,3.56-3.56,3.56,3.56,0,0,1-3.56,3.56m-27.74-47.42a3.56,3.56,0,1,1,3.56-3.56,3.56,3.56,0,0,1-3.56,3.56"
      transform="translate(-167.6 -120.78)"
      fill="#fff"
    />
  </svg>
);

export default CloudInfraImg;
